// Renamed from Blog.jsx to BlogPosts.jsx for /blog-posts route
import Blog from './Blog';
export default Blog;
